import React from 'react';

function CalendarPage() {
    return (
        <>
            <h2>Calendar</h2>
            <p>Coming Soon</p>
         </>
    );
}

export default CalendarPage;